import { useIntl } from 'react-intl'
import styled from 'styled-components'
import BodyText from '../Typography/BodyText'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

interface Props {
  stepLabel: string
  currentStepNumber: number
  totalSteps: number
}

function StepperProgressText(props: Props) {
  const {
    stepLabel,
    currentStepNumber,
    totalSteps,
  } = props
  const intl = useIntl()

  return <Container>
    <BodyText variant="medium" weight="bold" colour="normal-contrast">{stepLabel}</BodyText>
    <BodyText variant="small" colour="light-foreground-alt">{intl.formatMessage(
      {
        id: 'fzZnYVQy1vn4rvT0FYvB',
        defaultMessage: 'Step {currentStepNumber} of {totalSteps}',
        description: 'Stepper progress indicator showing current step out of total steps',
      },
      { currentStepNumber, totalSteps },
    )}
    </BodyText>
  </Container>
}

export default StepperProgressText
